import { Component } from '@angular/core';
import { environment } from '../../../environments/environment.development';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-unauthorized',
  standalone: true,
  templateUrl: './page-unauthorized.component.html',
  styleUrl: './page-unauthorized.component.scss'
})
export class PageUnauthorizedComponent {
  constructor(private router: Router) {}

  ngOnInit(): void {
    console.log('SCANNER WEB');
  }

  goBackToIntranetWeb(){
    this.router.navigateByUrl('/login');
  }
}
